<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateModal from "./create_modal.vue";
import DeleteModal from "./delete_modal.vue"
import { notify } from '@/helpers/notify' 

export default {
  page: {
    title: "İp Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CreateModal,
    DeleteModal
  },
  data() {
    return {
        title: "İP LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "İP LİSTESİ",
            active: true,
          },
        ],
        list: {},
        isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: [],
        pageLength: 0,
        url: "ips",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa',
          infoFn: (params) => `${params.firstRecordOnPage} - ${params.lastRecordOnPage} ( Toplam: ${params.totalRecords}) `,
      },
      selectOptions: {
        enabled: true,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          label: 'Nas',
          field: 'router_name',
          sortable:false,
          html: true,
          width: '25%',
          filterOptions: {
            customFilter: true
          }
        },
        {
          label: 'İp Tipi',
          field: 'type',
          width: '200px',
          sortable:false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: 'İp Tipi Filtrele',
            filterDropdownItems: [
              {
                value: 'l',
                text: 'Lokal İpler',
              },
              {
                value: 's', 
                text: 'Statik İpler',
              },
              {
                value: '', 
                text: 'Tümü',
              },
            ],
          },
        },
        {
          label: 'İp',
          field: 'ip',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'İp Filtrele',
            filterDropdownItems: [ ],
          },
        },
        {
          label: 'Müşteri',
          field: 'username',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Müşteri Filtrele',
            filterDropdownItems: [ ],
          },
        },
      ],
      routerList:[],
    };
  },
 
  mounted(){
    this.getRouterList()
  },
  methods: {
    getRouterList(){
      this.$http.post('/routers')
      .then(resp => this.routerList = resp.data.data )
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({ sort: params })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
          this.$http.post(this.url, this.serverParams)
            .then(res => {
              resolve({
                rows: res.data.data,
                totalRecords: res.data.meta.total,
                pageLength: res.data.meta.last_page,
                currentPage: res.data.meta.current_page,
              })
            })
            .catch(error => {
              reject(error)
            })
        })
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.map(obj => obj.id)
    },
    onSearch(params) {
      this.updateParams(params)
      this.loadItems()
     },
    create(){
      this.list = {}
      this.$parent.$bvModal.show('modal-ip')
    },
    update(props){
      this.list = props
      this.$parent.$bvModal.show('modal-ip')
    },
    sil(id){
      if(id){
        this.$http.delete('/ips/' + id)
        notify.success('Silindi')
        this.loadItems()
        return false
      }

      this.$parent.$bvModal.show('delete-ip')
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateModal 
      :list="list" 
      @loadItems="loadItems"/>

    <DeleteModal 
      :routerList="routerList"
      :deleteIds="selected"
       @loadItems="loadItems"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table 
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                  enabled: false,
                  placeholder: 'Arama İçin Enter\'a Basınız'
                }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <template slot="column-filter" slot-scope="{ column, updateFilters }">
                    <v-select 
                        v-if="column.filterOptions && column.filterOptions.customFilter"
                        :options="routerList"
                        :reduce="r => r.id"
                        @input="(value) => updateFilters(column, value)"
                        >
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                            {{ option.shortname  }} - {{ option.nasname  }}
                              </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                            {{ option.shortname  }} - {{ option.nasname  }}
                            </div>
                          </template>
                      <span slot="no-options">Sonuç Bulunamadı</span>
                    </v-select>
                </template>  
                <div slot="table-actions">
                  <div class="d-flex justify-content-between">
                    <button 
                      class="btn btn-outline-danger" 
                      style="margin-right:10px;margin-top:2px" 
                      type="button" 
                      @click="sil()"
                      > <i class="mdi mdi-trash-can-outline"></i> 
                      <span v-if="selected.length > 0">Seçili İpleri Sil</span>
                      <span v-else> İp Sil</span>
                    </button>
                    <button 
                      class="btn btn-success" 
                      style="margin-right:10px;margin-top:2px" 
                      type="button" 
                      @click="create()"
                      ><i class="mdi mdi-plus"></i>  Yeni Oluştur
                    </button>
                  </div>
                </div>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>